import SlideOutCatagoryMenu from 'components/SlideOutCatagoryMenu'
import Layout from 'Layout'
import CategoriesList from 'Layout/Navigation/CategoriesList'
import { GetServerSideProps } from 'next'
import { useContext, useEffect, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import { Category } from 'types/common-types'
import CategoriesWithProducts from 'components/Categories/CategoriesWithProducts'
import GridListViewToggle from 'components/Products/GridListViewToggle'
import { PreferencesContext } from '../../../context/Preferences'
import { Autocomplete } from 'components/Autocomplete'
import axios from 'axios'
import { api } from 'clients/axios'
import { getIdToken } from 'firebase/auth'
import { AuthContext } from 'context/Auth'
import toast from 'react-hot-toast'

interface Props {
	data: { productRegion: { categoriesCollection: { items: Category[] } } }
}

export default function StandardProducts({ data }: Props) {
	const { user, isAdmin } = useContext(AuthContext)
	const { productView } = useContext(PreferencesContext)
	const [categories, setCategories] = useState<Category[]>([])
	const [catagoriesMenuOpen, setCatagoriesMenuOpen] = useState(false)

	function handleCatagoriesMenuOpen(openClose: boolean) {
		setCatagoriesMenuOpen(openClose)
	}

	// When the data changes, add the categories to state
	useEffect(() => {
		if (data) {
			setCategories(data.productRegion.categoriesCollection.items)
		}
	}, [data])

	// Work around for next.js not scrolling to anchor links when coming from outside pages
	useEffect(() => {
		const path = window.location.hash
		// Some redirect bs to make an email link go to the right product cause someone f'd up
		const params = window.location.search
		if (params && params.includes('utm_campaign=cfe09f3afd-K+Materials+-+July+National+Email+v2')) {
			setTimeout(() => {
				window.location.hash = '#kindergarten-word-study-classroom-resources'
				const el = window.document.getElementById('kindergarten-word-study-classroom-resources') as HTMLElement
				const r = el.getBoundingClientRect()
				window.top?.scroll({
					top: scrollY + r.top - 80,
					behavior: 'smooth'
				})
			}, 600)
		} else if (path && path.includes('#')) {
			setTimeout(() => {
				const id = path.replace('#', '')
				const el = window.document.getElementById(id) as HTMLElement
				const r = el.getBoundingClientRect()
				window.top?.scroll({
					top: scrollY + r.top - 80,
					behavior: 'smooth'
				})
			}, 600)
		}
	}, [])

	async function rebuildSearchIndex() {
		if (!user && !isAdmin) throw new Error('Not authorized')
		const token = await getIdToken(user!!)
		await api.post(
			'/api/v1/algolia/product/build-index',
			{ standard: 'ccss' },
			{
				headers: {
					Authorization: token
				}
			}
		)
	}

	return (
		<Layout pageTitle="ARC Reorder Products">
			<img src="/images/reorder-banner.png" alt="reorder banner" />
			<div className="relative px-4 xl:px-0">
				<div className="sticky top-0 z-10 my-6 flex w-full items-center justify-between gap-4 bg-white py-3 sm:gap-0">
					{isAdmin && (
						<div>
							<button
								onClick={() =>
									toast.promise(rebuildSearchIndex(), {
										loading: 'Updating index...',
										success: 'Index updated!',
										error: 'Could not update the index.'
									})
								}
								data-tip="Rebuild Search Index"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									strokeWidth={1.5}
									stroke="currentColor"
									className="h-6 w-6"
								>
									<path
										strokeLinecap="round"
										strokeLinejoin="round"
										d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
									/>
								</svg>
							</button>
						</div>
					)}
					<div className="flex w-full justify-center">
						<Autocomplete />
					</div>
					<div className="z-10 block pt-2 pb-3 lg:hidden">
						<button className="flex gap-2" onClick={() => setCatagoriesMenuOpen(true)}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								strokeWidth={1.5}
								stroke="currentColor"
								className="h-6 w-6"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
								/>
							</svg>
						</button>
					</div>
					<GridListViewToggle />
				</div>

				<div className="relative flex w-full flex-col items-start gap-6 lg:flex-row">
					<div
						className="top-[70px] hidden overflow-auto border lg:sticky lg:block lg:w-1/4"
						style={{ maxHeight: 'calc(100vh - 120px)' }}
					>
						<CategoriesList categories={categories} />
					</div>

					<div className="w-full lg:w-3/4">
						{categories.map((category: Category) => (
							<CategoriesWithProducts
								view={productView}
								category={category}
								key={category.sys.id}
								region="standard"
							/>
						))}
					</div>
				</div>
			</div>
			<SlideOutCatagoryMenu
				open={catagoriesMenuOpen}
				setOpen={handleCatagoriesMenuOpen}
				catagories={categories}
			/>
			<ReactTooltip
				effect="solid"
				backgroundColor="#fff"
				textColor="#304157"
				borderColor="#E5E7EB"
				border
				className="max-w-xs text-center"
			/>
		</Layout>
	)
}

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
	res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=119')
	const headers = new Headers()
	headers.append('Authorization', `Bearer ${process.env.NEXT_PUBLIC_CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN}`)
	headers.append('Content-Type', 'application/json')

	const graphql = JSON.stringify({
		query: `
		query GET_PRODUCT_REGION_WITH_CATEGORIES_AND_PRODUCTS_QUERY {
			productRegion(id: "015FUZNAu3z3R0AFfhcrho") {
				categoriesCollection(limit: 50) {
					items {
						sys {
							id
						}
						name
						description
						categoryGroup
						slug
						language
						image {
							url
							height
							width
						}
						productsCollection(limit: 50) {
							items {
								name
								slug
								sku
								price
								salesforceProductId
								imagesCollection(limit: 3) {
									items {
										url
										height
										width
									}
								}
								sys {
									id
								}
							}
						}
					}
				}
			}
		}
		`
	})
	const requestOptions = {
		method: 'POST',
		headers,
		body: graphql
	}
	const response = await fetch(
		`https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/environments/production`,
		requestOptions
	)
	const { data } = await response.json()

	return {
		props: {
			data
		}
	}
}
